import React, { useState } from 'react';
import { Button } from '../Button/Button';
import { Modal } from '../Modal/Modal';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: (comment: string) => void;
  onSubmit: (comment: string) => void;
}

const FeedbackModal = ({ isOpen, onClose, onSubmit }: FeedbackModalProps) => {
  const [comment, setComment] = useState('');
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(comment)}
      className="feedback__modal"
      isDismissable={true}
      title="Thanks for letting us know, anything else?"
    >
      <textarea
        className="feedback__modal-input"
        maxLength={500}
        placeholder="Write something (optional)"
        onChange={(e) => setComment(e.target.value)}
        autoFocus
      />
      <div className="feedback__modal-actions">
        <span>Please do not include any personal information in your comment.</span>
        <Button onClick={() => onSubmit(comment)}>Submit</Button>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
